import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, generalUnitPrice, positiveInt } from '#validation';
import { newEnterprisePlanLimitsSchema, overageStorageSchema, prepaidMembersSchema, prepaidStorageSchema, updateBillingCustomerSchema, } from './common-billing.dto';
const storageProductAmendment = z.object({
    prepaid: prepaidStorageSchema,
    overage: overageStorageSchema.optional(),
});
const membersProductAmendment = z.object({
    prepaid: prepaidMembersSchema,
});
const teamCacheProductAmendment = z.object({
    installations: positiveInt,
    pricePerInstallation: generalUnitPrice,
});
const platformFeeProductAmendment = z.object({
    price: generalUnitPrice,
});
export const multiMonthlySubscriptionAmendment = z.object({
    amendedAt: dateParser(),
    periodStart: dateParser(),
    members: membersProductAmendment.optional(),
    awsStorage: storageProductAmendment.optional(),
    customStorage: storageProductAmendment.optional(),
    legacyProviders: z
        .object({
        wasabiStorage: storageProductAmendment.optional(),
        ibmStorage: storageProductAmendment.optional(),
    })
        .optional(),
    nativeLayout: storageProductAmendment.optional(),
    teamCache: teamCacheProductAmendment.optional(),
    platformFee: platformFeeProductAmendment.optional(),
});
const enterprisePlanAmendmentSchema = z
    .object({
    members: membersProductAmendment.optional(),
    awsStorage: storageProductAmendment.optional(),
    customStorage: storageProductAmendment.optional(),
    legacyProviders: z
        .object({
        wasabiStorage: storageProductAmendment.optional(),
        ibmStorage: storageProductAmendment.optional(),
    })
        .optional(),
    nativeLayout: storageProductAmendment.optional(),
    teamCache: teamCacheProductAmendment.optional(),
    platformFee: platformFeeProductAmendment.optional(),
    customer: updateBillingCustomerSchema.optional(),
    limits: newEnterprisePlanLimitsSchema.optional(),
})
    .refine((data) => Object.values(data).some(Boolean), {
    error: 'billing.updatePlan.amendment.emptyRequest',
});
export class EnterprisePlanAmendmentDto extends createZodDto(enterprisePlanAmendmentSchema) {
}
